
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/for-nutritionists",
      function () {
        return require("private-next-pages/fr/for-nutritionists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/for-nutritionists"])
      });
    }
  